import CopyBtn from 'components/CopyBtn'
import { ErrorMessage, Label } from 'components/Form'
import { Box, Flex } from 'theme-ui'
import { BasicInputGroupProps } from '.'

export const BasicInputGroup = ({
  label,
  name,
  error,
  disabled,
  display,
  input,
  copyableText,
  copyableTextName,
}: BasicInputGroupProps) => (
  <>
    <Label htmlFor={name}>
      {label}
      <Flex sx={{ mb: -2 }}>
        {copyableText && disabled && (
          <Box sx={{ ml: 3 }}>
            <CopyBtn
              copyText={copyableText}
              copyTextName={copyableTextName ?? label}
              size={24}
            />
          </Box>
        )}
      </Flex>
    </Label>
    {disabled ? display : input}
    <ErrorMessage>{error ? <span>{error}</span> : null}</ErrorMessage>
  </>
)
